module.exports = __webpack_public_path__ + "static/media/upload.7d1456b6.svg";